module.exports = __webpack_public_path__ + "c444204bcb2a95d7a80828ff288293ed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg_top_right.svg
// module id = 398
// module chunks = 0